import Sections from "./helpers/sections";
import PageTemplate from "./helpers/pagetemp";
import DocTable from "./helpers/DocTable";

const PUBLIC = process.env.PUBLIC_URL;

function MyArchive() {
    var potd_about = [
        <div className="spacious-text">
            Problem of the Day (POTD) sets are released weekly, with one problem per day. Problems get progressively
            <strong> more difficult from Monday to Sunday</strong>, and the <strong>Wednesday and Saturday</strong> problems
            are always <strong>proof-based</strong>, while the rest are computational.
        </div>
    ];

    var potd_table = (
        <DocTable
            columns={[{ key: "potd", header: "Problems" }]}
            rows={[
                {
                    label: "2023 – 2024",
                    links: {
                        potd: { path: `${PUBLIC}/Documents/POTDs/ARML_POTD_2024_Q2.pdf`, text: "View PDF" }
                    }
                },
                {
                    label: "2024 – 2025",
                    links: {
                        potd: { path: "https://mathdash.com/league/omc-24-25", text: "MathDash" }
                    }
                },
                {
                    label: "2025 – 2026",
                    links: {
                        potd: { path: "https://mathdash.com/league/omc-25-26", text: "MathDash" }
                    }
                }
            ]}
        />
    );

    var arml_tst_table = (
        <DocTable
            columns={[
                { key: "problems", header: "Problems" },
                { key: "solutions", header: "Solutions" }
            ]}
            rows={[
                {
                    label: "2023",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2023_TST.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2023_TST_Solutions.pdf` }
                    }
                },
                {
                    label: "2024 TST 1",
                    links: {
                        problems: null,
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2024_ARML_TST_1_SOLUTIONS.pdf` }
                    }
                },
                {
                    label: "2024 TST 2",
                    links: {
                        problems: null,
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2024_ARML_TST_2_SOLUTIONS.pdf` }
                    }
                },
                {
                    label: "2025 TST 1",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2025_ARML_TST_1_PROBLEMS.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2025_ARML_TST_1_SOLUTIONS.pdf` }
                    }
                },
                {
                    label: "2025 TST 2",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2025_ARML_TST_2_PROBLEMS.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2025_ARML_TST_2_SOLUTIONS.pdf` }
                    }
                },
                {
                    label: "2026 TST 1",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2026_ARML_TST_1_PROBLEMS.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2026_ARML_TST_1_SOLUTIONS.pdf` }
                    }
                },
                {
                    label: "2026 TST 2",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2026_ARML_TST_2_Problems.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2026_ARML_TST_2_SOLUTIONS.pdf` }
                    }
                }
            ]}
        />
    );

    var hmmt_tst_table = (
        <DocTable
            columns={[
                { key: "problems", header: "Problems" },
                { key: "solutions", header: "Solutions" }
            ]}
            rows={[
                {
                    label: "2024",
                    links: {
                        problems: null,
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2024_HMMT_TST.pdf`, text: "Solutions (incl. problems)" }
                    }
                },
                {
                    label: "2026",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2026_HMMT_TST_PROBLEMS.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2026_HMMT_TST_SOLUTIONS.pdf` }
                    }
                }
            ]}
        />
    );

    var warmups_note = [
        <div className="spacious-text">
            The ARML warmups below were used to prepare our team at the competition itself. They are <strong>not a TST</strong> —
            no one was selected for the team based on these problems — but are included here for additional practice.
        </div>
    ];

    var warmups_table = (
        <DocTable
            columns={[
                { key: "problems", header: "Problems" },
                { key: "solutions", header: "Solutions" }
            ]}
            rows={[
                {
                    label: "2026",
                    links: {
                        problems: { path: `${PUBLIC}/Documents/TSTs/2026_ARML_WARMUPS_PROBLEMS.pdf` },
                        solutions: { path: `${PUBLIC}/Documents/TSTs/2026_ARML_WARMUPS_SOLUTIONS.pdf` }
                    }
                }
            ]}
        />
    );

    var sections = [
        {
            "title": "Problem of the Day (POTD) Archive",
            "items": [...potd_about, potd_table],
            enhance: true
        },
        {
            "title": "ARML Team Selection Tests (TSTs)",
            "items": [arml_tst_table],
            enhance: true
        },
        {
            "title": "HMMT Team Selection Tests (TSTs)",
            "items": [hmmt_tst_table],
            enhance: true
        },
        {
            "title": "ARML Warmups",
            "items": [...warmups_note, warmups_table],
            enhance: true
        }
    ];

    return (
        <PageTemplate id="archive-page">
            <h1 className="my-5">Archive</h1>
            <Sections sections={sections} title_block={({ children }) => (<h4>{children}</h4>)} />
        </PageTemplate>
    );
}

export default MyArchive;
